import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import BackButton from '../BackButton';

// Styles
import styles from './index.module.sass';

const Notices = (props) => {
  const { device, history } = props;
  const { screenSize } = device;
  const { t } = useTranslation('notices');

  const notices = t('notices', { returnObjects: true });

  return (
    <div id={styles.Notices} className={styles[screenSize]}>
      <BackButton history={history} />
      <div className={styles.container}>
        <div className={styles.title}>{t('title')}</div>
        <div className={styles.notices}>
          {Array.isArray(notices) &&
            notices.map((val, key) => {
              const { name = '', link = '' } = val;
              return (
                <a
                  className={styles.notice}
                  key={key}
                  href={link}
                  target='_blank'
                  rel='noopener noreferrer'>{`${key + 1}.- ${name}`}</a>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Notices;
